import { Types } from '@store/types';

export const setCurrentActivePage = (data) => {
	try {
		return {
			type: Types.SET_CURRENT_ACTIVE_PAGE,
			payload: data
		};
	} catch {
		/* Empty Block */
	}
};

export const clearCurrentActivePage = () => {
	return {
		type: Types.CLEAR_CURRENT_ACTIVE_PAGE,
		payload: {
			id: null,
			type: '',
			pageType: 'DETAILS'
		}
	};
};
